// ─── Configuration Firebase — POINT DE BASCULE UNIQUE ─────────────
// Pouvoir viser un AUTRE projet Firebase sans toucher au code : la suite est
// née sur `mopcal-96460`, un projet dont le nom ne lui correspond plus.
//
// ⚠️ Une bascule ne DÉPLACE AUCUNE DONNÉE. Le projet visé démarre vide :
// comptes, espaces, inventaires, messages restent sur l'ancien projet. C'est
// un redémarrage propre, pas une migration — décidé ainsi avec Cédric.
// Reprendre les données demanderait en plus : export/import Auth en conservant
// les uid (tout référence des uid), export/import Firestore des DEUX bases, et
// copie du bucket Storage. Voir `BASCULE-PROJET-FIREBASE.md`.
//
// COMMENT BASCULER : renseigner les variables `EXPO_PUBLIC_FB_*` (fichier
// `.env` à la racine de l'app, ou variables d'environnement) puis réexporter.
// Expo REMPLACE `process.env.EXPO_PUBLIC_*` par sa valeur AU MOMENT DU BUNDLE :
// les accès doivent donc rester écrits en toutes lettres ci-dessous (un accès
// calculé, `env[cle]`, ne serait pas remplacé et vaudrait `undefined`).
//
// La clé Web est publique par nature — c'est le rôle des règles Firestore de
// protéger la donnée, pas celui de la clé.

// Projet historique — valeur de repli tant qu'aucune variable n'est posée.
const DEFAUT = {
  apiKey: 'AIzaSyCNaW1qmqDlzN-ITYij_yxQpON-v_sS_G0',
  authDomain: 'mopcal-96460.firebaseapp.com',
  projectId: 'mopcal-96460',
  storageBucket: 'mopcal-96460.firebasestorage.app',
  messagingSenderId: '356514335702',
  appId: '1:356514335702:web:60c16d5da245ce3a583277',
  dbApp: 'mopcal-app',
};

export const firebaseConfig = {
  apiKey:            process.env.EXPO_PUBLIC_FB_API_KEY        || DEFAUT.apiKey,
  authDomain:        process.env.EXPO_PUBLIC_FB_AUTH_DOMAIN    || DEFAUT.authDomain,
  projectId:         process.env.EXPO_PUBLIC_FB_PROJECT_ID     || DEFAUT.projectId,
  storageBucket:     process.env.EXPO_PUBLIC_FB_STORAGE_BUCKET || DEFAUT.storageBucket,
  messagingSenderId: process.env.EXPO_PUBLIC_FB_SENDER_ID      || DEFAUT.messagingSenderId,
  appId:             process.env.EXPO_PUBLIC_FB_APP_ID         || DEFAUT.appId,
};

// Base Firestore NOMMÉE (config, forfaits, IVV, fiches de test). Séparée de la
// base `(default)` ; elle existe aussi dans le projet cible, sous ce nom-là ou
// sous un autre (c'est l'occasion de la renommer).
export const DB_APP = process.env.EXPO_PUBLIC_FB_DB_APP || DEFAUT.dbApp;

// Région des Cloud Functions — doit correspondre à celle où elles sont déployées.
export const REGION_FONCTIONS = process.env.EXPO_PUBLIC_FB_REGION || 'europe-west9';

// Vrai si on ne vise PAS le projet historique. Sert au garde-fou de firebase.js :
// une app qui écrit dans une autre base doit le dire, sinon on croit toucher la
// prod alors qu'on est ailleurs — ou l'inverse, ce qui est pire.
export const PROJET_PAR_DEFAUT = DEFAUT.projectId;
export const projetSurcharge = firebaseConfig.projectId !== DEFAUT.projectId;

// Libellé lisible du projet visé (22/08) — affiché dans Profil → À propos,
// pour qu'on sache d'un coup d'œil si l'app parle à la base de test
// (MopCal, `mopcal-96460`) ou à la vraie base de production (MopSuite,
// `mopsuite`). Un projet non listé retombe sur son identifiant brut.
const LIBELLES_PROJET = { 'mopcal-96460': 'MopCal', mopsuite: 'MopSuite' };
export const libelleProjet = LIBELLES_PROJET[firebaseConfig.projectId] || firebaseConfig.projectId;

// ── Émulateurs locaux (socle de TEST, 08/08) ──────────────────────
// `EXPO_PUBLIC_FB_EMULATEURS=1` fait parler l'app aux émulateurs Firebase au
// lieu du projet réel. ABSENTE = comportement d'avant, à l'identique : c'est la
// garantie donnée aux quatre autres postes, ce fichier est partagé.
// Accès écrit en toutes lettres (cf. l'avertissement en haut du fichier : Expo
// ne remplace que les accès littéraux, un accès calculé vaudrait `undefined`).
export const EMULATEURS = process.env.EXPO_PUBLIC_FB_EMULATEURS === '1';

// Hôte joignable depuis l'appareil qui exécute l'app : `localhost` en web, mais
// un téléphone sur le réseau a besoin de l'IP de la machine.
export const EMU_HOTE  = process.env.EXPO_PUBLIC_FB_EMU_HOTE || 'localhost';
export const EMU_PORTS = { auth: 9099, firestore: 8080, storage: 9199 };
